import { init } from '@rematch/core';
import immerPlugin from '@rematch/immer';
import { Provider, connect, useSelector, useDispatch } from 'react-redux';
import logger from 'redux-logger';
import main from './models/main';
import common from './models/common';

const initSetting = {
  models: {
    main,
    common,
  },
  // 使用immer进行转化state为immutable
  plugins: [immerPlugin()],
};

if (process.env.NODE_ENV !== 'production') {
  initSetting.redux = {
    middlewares: [logger],
  };
}
// 初始化状态
const store = init(initSetting);

export { store, Provider, connect, useSelector, useDispatch };
